import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import MemberMentorshipDashboardPage from "@/pages/member/MemberMentorshipDashboardPage";

export const Route = createFileRoute("/member/mentorship/dashboard")({
  head: () => pageHead("Member · Mentorship · Dashboard", "AKIVA member · mentorship · dashboard portal.", "/member/mentorship/dashboard", true),
  component: MemberMentorshipDashboardPage,
});
